import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Vendas1 from '../imagens/LancVendas/Vendas1.png';
import Vendas2 from '../imagens/LancVendas/Vendas2.png';
import Vendas3 from '../imagens/LancVendas/Vendas3.png';
import Vendas4 from '../imagens/LancVendas/Vendas4.png';
import Vendas5 from '../imagens/LancVendas/Vendas5.png';
import Vendas6 from '../imagens/LancVendas/Vendas6.png';
import Vendas7 from '../imagens/LancVendas/Vendas7.png';
import Vendas8 from '../imagens/LancVendas/Vendas8.png';

export default class Vendas extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como utilizar o gerenciamento de vendas"
        visible={isOpen}
        className="modal"
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <Col>
          <h3 style={{ fontSize: 26, marginTop: 18 }}>Acesso à tela</h3>
          {/* <p style={{ fontSize: 18, marginTop: 18 }}>Para acessar o gerenciamento de vendas siga o seguinte atalho:  </p> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas1} alt="Vendas 1" style={{ marginTop: 15, maxWidth: "70%", height: "auto", objectFit: "contain", paddingBottom: 28 }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <h3 style={{ fontSize: 26, marginTop: 18 }}>Na tela de Vendas nós temos:</h3>
          <ol style={{ fontSize: 18, marginTop: 18 }}>
            <li>Botão para gerar uma nova venda.</li>
            <li>Filtros para busca de vendas e botão de impressão do relatório de vendas.</li>
            <li>Tabela trazendo todas as vendas ja feitas.</li>
            <li>Botões auxiliares de alteração/exclusão/impressão da venda.</li>
            <li>Navegação das páginas da tabela de vendas.</li>
          </ol>
          
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas2} alt="Vendas 2" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <h3 style={{ fontSize: 26, marginTop: 18 }}>Como gerar uma nova Venda</h3>

          <p style={{ fontSize: 18, marginTop: 18 }}>Para gerar uma nova venda basta clicar no botão "Adicionar" no canto superior esquerdo da tela</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas3} alt="Vendas 3" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <p style={{ fontSize: 18, marginTop: 18 }}>Depois, preencha os campos necessários corretamente. O cadastro de vendas possui três abas: <b>Dados principais, lista dos Produtos, e Forma de Pagamento.</b> </p>
          <p style={{ fontSize: 18, marginTop: 18 }}>A aba de dados principais possui apenas dados simples. O valor da venda e quantidade de produtos será definida pelas outras duas abas.</p>
          <p style={{ fontSize: 18, marginTop: 18 }}>Caso seja necessário emitir nota fiscal não esquecer de marcar a opção "Emitir NFe".</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas4} alt="Vendas 4" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain", paddingBottom: 28 }} />
          </div>

          <p style={{ fontSize: 18, marginTop: 18 }}>A segunda aba de lista dos Produtos é onde o gestor pode adicionar os itens que foram vendidos. O valor e quantidade desses itens irá definir o valor da venda.</p>
          <p style={{ fontSize: 18, marginTop: 18 }}>Para adicionar um item a venda basta clicar no botão "+ Novo Produto", preencher os dados do item e clicar em salvar</p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas5} alt="Vendas 5" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain", paddingBottom: 28 }} />
          </div>

          <p style={{ fontSize: 18, marginTop: 18 }}>A terceira e última aba define a forma de pagamento e valores de parcelas em caso de venda parcelada</p>
          <p style={{ fontSize: 18, marginTop: 18 }}>
            Após escolher o Tipo de documento e Condição de pagamento, se o gestor já adicionou itens a venda (segunda aba),
            ele pode clicar no botão de calcular Parcelas (botão com a calculadora) para calcular o valor do pagamento da venda.
          </p>

          <p style={{ fontSize: 18, marginTop: 18 }}>Após calcular o valor do pagamento, para completar a venda basta clicar no botão "Salvar Venda".</p>
          <p style={{ fontSize: 18, marginTop: 18 }}>Lembre que se as parcelas não forem calculadas e inclusas na venda, a venda não irá gerar lançamento financeiro.</p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas6} alt="Vendas 6" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain", paddingBottom: 28 }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />
          <h3 style={{ fontSize: 26, marginTop: 18 }}>Como alterar/Excluir uma venda</h3>
          <p style={{ fontSize: 18, marginTop: 18 }}>Para  Alterar/Excluir uma venda utilize as opções extras dentro da tabela de registros.</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas7} alt="Vendas 7" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />
          <h3 style={{ fontSize: 26, marginTop: 18 }}>Como filtrar as vendas</h3>
          <p style={{ fontSize: 18, marginTop: 18 }}>
            Para facilitar a busca de uma venda específica você pode utilizar a barra de pesquisa na parte superior da tabela. A informação que você pode buscar
            está sugerida dentro do campo.
          </p>
          <p style={{ fontSize: 18, marginTop: 18 }}>
            Caso apenas um campo não for suficiente, você pode usar os filtros extras clicando no botão "Filtrar".
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Vendas8} alt="Vendas 8" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
          </div>

          </Col>
        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancVendas.js